/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".value-allocation[_ngcontent-%COMP%]{min-width:150px;display:flex;align-items:center;justify-content:space-between}.value-allocation[_ngcontent-%COMP%]   .form-control-sm[_ngcontent-%COMP%]{margin-left:5px;width:90%}.percent-allocation[_ngcontent-%COMP%]{min-width:80px;display:flex;align-items:center;justify-content:space-between}.percent-allocation[_ngcontent-%COMP%]   .form-control-sm[_ngcontent-%COMP%]{margin-right:5px;width:90%}"];
export { styles as styles };
